import { HttpParams } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

import { CmpsDatePipe } from '../common/date.pipe';

import { TranslationKeyMap } from './widget.i18n';

const WEB_FORMS_SCORECARD_DISPLAY_URL = '/Scorecard/ScorecardDisplay.aspx';
const WEB_FORMS_TEAM_DASHBOARD_URL = '/TeamDashboard/TeamDashboard.aspx';

// TODO remove
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function generateScorecardModalHeader(
    translateService: TranslateService,
    datePipe: CmpsDatePipe,
    username: string,
    startDate: Date,
    endDate: Date,
) {
    const sd = datePipe.transform(startDate, 'y-MM-dd');
    const ed = datePipe.transform(endDate, 'y-MM-dd');
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    return translateService.instant(
        TranslationKeyMap._802_SCORECARD___SUBTITLE_,
        {
            subtitle: `${username || ''} ${
                username ? '-' : ''
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            } (${sd} to ${ed})`,
        },
    ); // TODO revise tl
}

export function createWebFormsScorecardUrl(
    datePipe: CmpsDatePipe,
    options: {
        id: number;
        name?: string;
        userId: number;
        username?: string;
        startDate: Date;
        endDate: Date;
        periodTypeId: number;
    },
): string {
    const startDate = datePipe.transform(options.startDate, 'y-MM-dd');
    const endDate = datePipe.transform(options.endDate, 'y-MM-dd');

    const params = new HttpParams()
        .set('ScorecardID', options.id.toString())
        .set('ScorecardName', options.name)
        .set('UserID', options.userId.toString())
        .set('Username', options.username)
        .set('StartDate', startDate)
        .set('EndDate', endDate)
        .set('PeriodTypeID', options.periodTypeId.toString());

    return `${WEB_FORMS_SCORECARD_DISPLAY_URL}?${params.toString()}`;
}

export function createTeamDashboardUrl(
    datePipe: CmpsDatePipe,
    userId: number,
    date: Date | number,
    p: number,
): string {
    const d = datePipe.transform(date, 'y-MM-dd');
    const params = new HttpParams()
        .set('i', userId.toString())
        .set('d', d)
        .set('p', p.toString());
    return `${WEB_FORMS_TEAM_DASHBOARD_URL}?${params.toString()}`;
}
